import { useMemo } from 'react';

import { KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';
import { ArgumentDisplay } from './components/ArgumentDisplay';
import { CurrencyDisplay } from './components/CurrencyDisplay';

interface Props {
  trigger: Trigger;
}

export function LynxTriggerFullDetails({ trigger }: Props) {
  const poolAddress = useMemo(() => {
    // Use context (new approach)
    if (trigger.context?.poolAddress) {
      return trigger.context.poolAddress;
    }

    // @deprecated - Fallback to signature extraction for legacy triggers
    if (trigger.signature) {
      const match = trigger.signature.match(/@([^@]+)$/);
      return match ? match[1] : '-';
    }

    return '-';
  }, [trigger.context?.poolAddress, trigger.signature]);

  const conditionExpression = useMemo(() => {
    return trigger.context?.condition_expression ?? trigger.conditionExpression ?? '-';
  }, [trigger.context?.condition_expression, trigger.conditionExpression]);

  const contractDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          Snapshots of
        </Text>
        <ArgumentDisplay value="LynxTradePositions" suffix="subgraph" />
      </div>
    );
  }, []);

  const volumeCurrencyDisplay = useMemo(() => {
    if (!trigger.currencyVolumeExpression) return '-';

    const chainId = trigger.contracts?.[0]?.chainId ?? 1;
    return <CurrencyDisplay value={trigger.currencyVolumeExpression} chainId={chainId} />;
  }, [trigger.currencyVolumeExpression, trigger.contracts]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Pool Address" value={poolAddress} />
      <KeyValueRow label="Executed with" value={contractDisplay} />
      <KeyValueRow label="Volume currency" value={volumeCurrencyDisplay} />
      <KeyValueRow label="Condition Expression" value={conditionExpression} />
    </KeyValueTable>
  );
}
